import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tabulator-select",
  "use": "icon-tabulator-select-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tabulator-select\">\n<path d=\"M11.4999 11.5L9.83319 15.6667L6.49986 6.5L15.6665 9.83334L11.4999 11.5ZM11.4999 11.5L15.6665 15.6667M4.99005 0.86544L5.6371 3.28025M3.28005 5.63727L0.865234 4.99022M10.6246 2.37525L8.85685 4.14301M4.14288 8.85698L2.37512 10.6247\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol